export default {
  title: "Invoice lines",

  input: {
    title: "Edit invoice lines",
    emptyLine: "Blank line",
    vat: "VAT:"
  },

  header: {
    line: "Text",
    price: "Price",
    vatPercent: "VAT%",
    vatTotal: "VAT",
    total: "Total",
  },

  footer: {
    total: "Total",
  },

  button: {
    addInvoiceLine: "Simple line",
    addEmptyLine: "Blank line",
  },

  addLine: {
    require: {
      tax: "Unknown default tax",
    },
  },
}
